import { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/auth.js';

export interface GuestGate {
  /** No session: the page shows the game, and everything that acts for a member is skipped. */
  isGuest: boolean;
  /** Sends the visitor to sign in, and back to this game afterwards. */
  signIn: () => void;
}

/**
 * Originals open for a visitor who has not signed in, the way BC.Game and
 * Duel do: the game renders, and the first thing that would stake money asks
 * for a sign-in instead.
 */
export function useGuestGate(): GuestGate {
  const isGuest = !useAuthStore((s) => s.accessToken);
  const navigate = useNavigate();
  const signIn = useCallback(() => {
    const back = `${window.location.pathname}${window.location.search}`;
    void navigate({ to: '/login', search: { redirect: back } });
  }, [navigate]);
  return { isGuest, signIn };
}
